module.exports = __webpack_public_path__ + "img/banner-mob.d716b58c.png";